export const publications = [
  {
    citation: "Sanchez, J.; Marquez-Ibarrab, C. A.; Buratowski, A.; Mayer, K. M.; Mangum. J.; Xu, F.* High-Power Impulse Plasma Assisted One-step Synthesis of High Surface Area Carbon for Hydrogen Storage, Int. J. Hydrog. 2026.",
    doi: "DOI:10.1016/j.ijhydene.2026.157210",
    doiLink: "https://doi.org/10.1016/j.ijhydene.2026.157210",
  },
  {
    citation: "Sutherland, K.; Xu, F.* Coverage dependent atomic structures of copper nitride on Cu(111). J. Vac. Sci. Technol. A 2026, 44 (5). 2026.",
    doi: "DOI:10.1116/6.0005619 (Editor's Picks)",
    doiLink: "https://doi.org/10.1116/6.0005619",
  },
  {
    citation: "Sutherland, K.; Lee, D.; Sanchez, J.; Buratowski, A.; Al-Mahboob, A.; Stacchiola, D.;* Xu, F.*, Domain Dependent Electronic Properties of 2D Copper Boride Synthesized from Reversible Subsurface Diffusion on Cu(111). J. Phys. Chem. Lett. 2026, 17 (3), 862–867.",
    doi: "DOI:10.1021/acs.jpclett.5c03605",
    doiLink: "https://doi.org/10.1021/acs.jpclett.5c03605",
  },
  {
    citation: "Lamichhane, B.; Lee, D.; Gautam, B.; Ponce, A.; Xu, F.*; Kattel, S.*, The Selection of Stable Pt Single-Atom Catalysts Supported on 3d–5d Transition Metal Carbides. Chem. Mater. 2025, 37, 9, 3158–3170.",
    doi: "DOI:10.1021/acs.chemmater.4c03276",
    doiLink: "https://doi.org/10.1021/acs.chemmater.4c03276",
  },
  {
    citation: "Sanchez, J.; Lamichhane, B.; Sutherland, K.; Kattel, S.*; Xu, F.*, Initial Carbonation of Ni(111). ACS Appl. Mater. Interfaces 2025, 17, 3, 5439–5445.",
    doi: "DOI:10.1021/acsami.4c16639",
    doiLink: "https://doi.org/10.1021/acsami.4c16639",
  },
  {
    citation: "Hu, T.; Karagoz, B.; Xu, F.;Head, A.R.; Weissenrieder, J.; Stacchiola, D., The surface chemistry of cuprous oxide. Surf. Sci. 2025, 751, 122622.",
    doi: "DOI:10.1016/j.susc.2024.1226223",
    doiLink: "https://doi.org/10.1016/j.susc.2024.122622",
  },
  {
    citation: "Graciani, J.; Grinter, D.C.; Ramírez, P.J.; Palomino, R.M.; Xu, F.; Waluyo, I.; Stacchiola, D.; Fdez Sanz, J.; Senanayake, S.D.; Rodriguez, J.A., Conversion of CO2 to Methanol and Ethanol on Pt/CeOx/TiO2(110): Enabling Role of Water in C–C Bond Formation. ACS Catal. 2022, 12 (24), 15097-15109.",
    doi: "DOI:10.1021/acscatal.2c03823",
    doiLink: "https://doi.org/10.1021/acscatal.2c03823",
  },
  {
    citation: "Xu, F.*; An, W.; Baber, A.E.; Grinter, D.C.; Senanayake, S.D.; White, M. G.; Liu, P.; Stacchiola, D. J., Enhanced Oxide Reduction by Hydrogen at Cuprous Oxide–Copper Interfaces near Ascending Step Edges. J. Phys. Chem. C 2022, 126 (44), 18645-18651.",
    doi: "DOI:10.1021/acs.jpcc.2c03719",
    doiLink: "https://doi.org/10.1021/acs.jpcc.2c03719",
    specialDescription: "(front cover)",
    image: "/publications/jpcc front cover_ck_v126i044.jpg"
  },
  {
    citation: "Grinter, D.C., Graciani, J., Luo, S., Palomino, R., Xu, F., Waluyo, I., Fernandez-Sanz, J., Senanayake, S.D., Rodriguez J.A. Adsorption and Activation of CO2 on Pt/CeOx/TiO2(110): Role of the Pt-CeOx interface. Surf. Sci. 2021, 710, 121852.",
    doi: "DOI:10.1016/j.susc.2021.121852",
    doiLink: "https://doi.org/10.1016/j.susc.2021.121852",
  },
  {
    citation: "Walenta, C.A.; Xu, F.; Tesvara, C.; O’Connor, C.R.; Sautet, P.; Friend, C.M. Facile Decomposition of Organophosphonates by Dual Lewis Sites on a Fe3O4(111) Film. J. Phys. Chem. C 2020, 124 (23), 12432-12441.",
    doi: "DOI:10.1021/acs.jpcc.0c01708",
    doiLink: "https://doi.org/10.1021/acs.jpcc.0c01708",
  },
  {
    citation: "O’Connor, C.R., van Spronsen, M.A., Egle, T., Xu, F., Kersell, H.R., Oliver-Meseguer, J., Karatok, M., Salmeron, M., Madix, R.J., Friend, C.M. Hydrogen migration at restructuring palladium–silver oxide boundaries dramatically enhances reduction rate of silver oxide. Nat. Commun. 11:1844, 2020.",
    doi: "DOI:10.1038/s41467-020-15536-x",
    doiLink: "https://doi.org/10.1038/s41467-020-15536-x",
  },
  {
    citation: "Xu, F., Chen, W., Walenta, C.A., O’Connor, C.R., Friend, C.M. Dual Lewis site creation for activation of methanol on Fe3O4(111) thin films. Chem. Sci. 11 (9):2448-2454, 2020.",
    doi: "DOI:10.1039/C9SC06149E",
    doiLink: "https://doi.org/10.1039/C9SC06149E"
  },
  {
    citation: "Xu, F., Montemore, M.M., O’Connor, C.R., Muramoto, E., van Spronsen, M.A., Madix, R.J., Friend, C.M. Oxygen adsorption on spontaneously reconstructed Au(511). Surf. Sci. 697:296-303, 2019.",
    doi: "DOI:10.1016/j.susc.2018.09.012",
    doiLink: "https://doi.org/10.1016/j.susc.2018.09.012",
  },
  {
    citation: "Waluyo, I., Mudiyanselage, K., Xu, F., An, W., Liu, P., Boscoboinik, J.A., Rodriguez, J.A., Stacchiola, D.J. Potassium-promoted reduction of Cu2O/Cu(111) by CO. J. Phys. Chem. C 123(13):8057-8066, 2019.",
    doi: "DOI:10.1021/acs.jpcc.8b07403",
    doiLink: "https://doi.org/10.1021/acs.jpcc.8b07403",
  },
  {
    citation: "Hamlyn, R.C.E., Mahapatra, M., Grinter, D.C., Xu, F., Luo, S., Palomino, R.M., Kattel, S.,Waluyo, I., Liu, P., Stacchiola, D.J., Senanayake, S.D., Rodriguez, J.A. Imaging the ordering of a weakly adsorbed two-dimensional condensate: ambient-pressure microscopy and spectroscopy of CO2 molecules on rutile TiO2(110). Phys. Chem. Chem. Phys. 20(19):13122-13126, 2018.",
    doi: "DOI:10.1039/C8CP01614C",
    doiLink: "https://doi.org/10.1039/C8CP01614C",
  },
  {
    citation: "Friend, C.M., Xu, F. Perspectives on the design of nanoparticle systems for catalysis. Faraday Discuss. 208:595-607, 2018.",
    doi: "DOI:10.1039/C8FD00124C",
    doiLink: "https://doi.org/10.1039/C8FD00124C",
  },
  {
    citation: "Walenta, C.A., Crampton, A.S., Xu, F., Heiz, U., Friend, C.M. Chemistry of methanol and ethanol on ozone-prepared α-Fe2O3(0001). J. Phys. Chem. A. 122 (44):25404–25410, 2018.",
    doi: "DOI:10.1021/acs.jpcc.8b07574",
    doiLink: "https://doi.org/10.1021/acs.jpcc.8b07574",
  },
  {
    citation: "Xu, F., Fampiou, I., O’Connor, C.R., Karakalos, S., Hiebel, F., Kaxiras, E., Madix, R.J., Friend, C.M. Water facilitates oxygen migration on gold surfaces. Phys. Chem. Chem. Phys. 20:2196-2204, 2018.",
    doi: "DOI:10.1039/C7CP06451A",
    doiLink: "https://doi.org/10.1039/C7CP06451A",
  },
  {
    citation: "Xu, F., Madix, R.J., Friend, C.M. Spatially nonuniform reaction rates during selective oxidation on gold. J. Am. Chem. Soc. 140:12210-12215, 2018.",
    doi: "DOI:10.1021/jacs.8b07438.",
    doiLink: "https://doi.org/10.1021/jacs.8b07438",
    specialDescription: "(featured in JACS Spotlights)",
    image: "/publications/spotlights.gif"
  },
  {
    citation: "Mudiyanselage, K., Xu, F., Hoffmann, F.M., Hrbek, J., Waluyo, I., Boscoboinik, J.A., Stacchiola, D.J. Adsorbate-driven morphological changes on Cu(111) nano-pits. Phys.Chem. Chem. Phys. 17:3032-3038, 2015.",
    doi: "DOI:10.1039/C4CP05088F",
    doiLink: "https://doi.org/10.1039/C4CP05088F",
  },
  {
    citation: "An, W., Xu, F., Stacchiola, D., Liu, P. Potassium-induced effect on the structure and chemical activity of the CuxO/Cu(111) (x≤2) surface: a combined scanning tunneling microscopy and density functional theory study. Chem. Cat. Chem. 7: 3865-3872, 2015.",
    doi: "DOI:10.1002/cctc.201500719",
    doiLink: "https://doi.org/10.1002/cctc.201500719",
    specialDescription: "(back cover)",
    image: "/publications/cctc201501188-toc-0001-m.jpg"
  },
  {
    citation: "Xu, F., Mudiyanselage, K., Baber, A.E., Soldemo, M., Weissenrieder, J., White, M.G., Stacchiola, D.J. Redox-mediated reconstruction of copper during carbon monoxide oxidation. J. Phys. Chem. C 118:15902-15909, 2014.",
    doi: "DOI:10.1021/jp5050496",
    doiLink: "https://doi.org/10.1021/jp5050496",
  },
  {
    citation: "An, W., Baber, A.E., Xu, F., Soldemo, M., Weissenrieder, J., Stacchiola, D., Liu, P. Mechanistic study of CO titration on CuxO/Cu(111) (x≤2) surfaces. Chem. Cat. Chem. 6: 2364-2372,2014.",
    doi: "DOI:10.1002/cctc.201402177",
    doiLink: "https://doi.org/10.1002/cctc.201402177",
  },
  {
    citation: "Graciani, J., Mudiyanselage, K., Xu, F., Baber, A.E., Evans, J., Senanayake, S.D., Stacchiola, D.J., Liu, P., Hrbek, J., Sanz, J.F., Rodriguez, J.A. Highly active copper-ceria and copper-ceria-titania catalysts for methanol synthesis from CO2. Science 345:546-550, 2014.",
    doi: "DOI:10.1126/science.1253057",
    doiLink: "https://doi.org/10.1126/science.1253057",
  },
  {
    citation: "Cheng, F.F., Zhang, J.J., Xu, F., Hu, L.H., Abdel-Halim, E.S., Zhu, J.J. pH-sensitive polydopamine nanocapsules for cell imaging and drug delivery based on folate receptor targeting. J. Biomed. Nanotechnol. 9:1155-1163, 2013.",
    doi: "DOI:10.1166/jbn.2013.1611",
    doiLink: "https://doi.org/10.1166/jbn.2013.1611",
  },
  {
    citation: "Baber, A.E., Xu, F., Dvorak, F., Mudiyanselage, K., Soldemo, M., Weissenrieder, J., Senanayake, S.D., Sadowski, J.T., Rodriguez, J.A., Matolin, V., White, M.G., Stacchiola, D.J. In situ imaging of Cu2O under reducing conditions: formation of metallic fronts by mass transfer. J. Am. Chem. Soc. 135:16781-16784, 2013.",
    doi: "DOI:10.1021/ja408506y",
    doiLink: "https://doi.org/10.1021/ja408506y",
  },
];